import React, { useState } from "react";
import { Link } from "react-router-dom";
import Translate from "../../common/Translate";

const Navbar = () => {
  const [activeItem, setActiveItem] = useState("Home");
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { name: "Home", type: "anchor", href: "#home" },
    { name: "About", type: "anchor", href: "#about" },
    { name: "Tokenomics", type: "anchor", href: "#tokenomics" },
    { name: "Roadmap", type: "route", href: "/roadmap" },
    { name: "FAQs", type: "anchor", href: "#faqs" },
    { name: "Contact", type: "anchor", href: "#contact" },
  ];

  return (
    <header className="w-full">
      <div className="mx-auto flex max-w-[1300px] items-center justify-between px-4 sm:px-6 lg:px-8">
        {/* Logo */}
        <div className="flex shrink-0 items-center">
          <Link to="/">
            <img
              src="/logo1.png"
              alt="Ethra AI"
              className="h-10 w-auto object-contain lg:h-20"
            />
          </Link>
        </div>

        {/* Desktop Menu */}
        <nav className="hidden items-center gap-8 md:flex lg:gap-10">
          {navItems.map((item) => {
            const isActive = activeItem === item.name;

            if (item.type === "route") {
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setActiveItem(item.name)}
                  className={`relative pb-1 text-[17px] font-medium transition-colors duration-200 ${
                    isActive
                      ? "text-[#e9fe3a]"
                      : "text-white hover:text-[#e9fe3a]"
                  }`}
                >
                  <Translate>{item.name}</Translate>

                  {isActive && (
                    <span className="absolute left-0 top-full mt-[6px] h-[2px] w-full bg-[#e9fe3a]" />
                  )}
                </Link>
              );
            }

            return (
              <a
                key={item.name}
                href={item.href}
                onClick={() => setActiveItem(item.name)}
                className={`relative pb-1 text-[17px] font-medium transition-colors duration-200 ${
                  isActive
                    ? "text-[#e9fe3a]"
                    : "text-white hover:text-[#e9fe3a]"
                }`}
              >
                <Translate>{item.name}</Translate>

                {isActive && (
                  <span className="absolute left-0 top-full mt-[6px] h-[2px] w-full bg-[#e9fe3a]" />
                )}
              </a>
            );
          })}
        </nav>

        {/* Join Button */}
        <div className="hidden md:block">
       <Link
  to="/presale"
  className="inline-block rounded-[10px] border border-[#c8f53a] bg-[linear-gradient(180deg,#b5e003_0%,#9dcb01_100%)] px-7 py-3 text-[17px] font-bold text-[#1c1c1c] shadow-[inset_0_1px_0_rgba(255,255,255,0.18),0_4px_14px_rgba(157,203,1,0.28)] transition duration-200 hover:brightness-105"
>
  <Translate>Join Presale</Translate>
</Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="text-white md:hidden"
          onClick={() => setMenuOpen(true)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-7 w-7"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="1.8"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>

      {/* Mobile Drawer */}
      <div
        className={`fixed inset-0 z-50 bg-black/60 transition-opacity duration-300 ${
          menuOpen
            ? "pointer-events-auto opacity-100"
            : "pointer-events-none opacity-0"
        }`}
        onClick={() => setMenuOpen(false)}
      >
        <div
          className={`absolute right-0 top-0 h-full w-[80%] max-w-[320px] transform border-l border-[#1f1f1f] bg-black transition-transform duration-500 ${
            menuOpen ? "translate-x-0" : "translate-x-full"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex items-center justify-between border-b border-white/10 px-5 py-4">
            <Link to="/" onClick={() => setMenuOpen(false)}>
              <img
                src="/logo1.png"
                alt="Ethra AI"
                className="h-9 w-auto object-contain"
              />
            </Link>

            <button
              onClick={() => setMenuOpen(false)}
              className="text-3xl text-white"
            >
              ×
            </button>
          </div>

          {/* Mobile Links */}
          <nav className="flex flex-col gap-5 px-5 py-6">
            {navItems.map((item) => {
              const isActive = activeItem === item.name;

              if (item.type === "route") {
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    onClick={() => {
                      setActiveItem(item.name);
                      setMenuOpen(false);
                    }}
                    className={`border-b pb-3 text-[18px] font-medium ${
                      isActive
                        ? "border-[#e9fe3a] text-[#e9fe3a]"
                        : "border-white/10 text-white hover:text-[#e9fe3a]"
                    }`}
                  >
                    <Translate>{item.name}</Translate>
                  </Link>
                );
              }

              return (
                <a
                  key={item.name}
                  href={item.href}
                  onClick={() => {
                    setActiveItem(item.name);
                    setMenuOpen(false);
                  }}
                  className={`border-b pb-3 text-[18px] font-medium ${
                    isActive
                      ? "border-[#e9fe3a] text-[#e9fe3a]"
                      : "border-white/10 text-white hover:text-[#e9fe3a]"
                  }`}
                >
                  <Translate>{item.name}</Translate>
                </a>
              );
            })}

            <Link
  to="/presale"
  className="inline-block rounded-[10px] border border-[#c8f53a] bg-[linear-gradient(180deg,#b5e003_0%,#9dcb01_100%)] px-7 py-3 text-[17px] font-bold text-[#1c1c1c] shadow-[inset_0_1px_0_rgba(255,255,255,0.18),0_4px_14px_rgba(157,203,1,0.28)] transition duration-200 hover:brightness-105"
>
  <Translate>Join Presale</Translate>
</Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Navbar;